import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function TransformedAlertsSaveDataService(token,data,selectedFile) {
    const formData = new FormData();

    // alerts JSON
    formData.append("data", JSON.stringify(data));

    // files (array of File)
    if (Array.isArray(selectedFile)) {
        selectedFile.forEach(file => {
            if (file instanceof File) {
                formData.append("file", file?file:'');
            }
        });
    }

    return axios.post(`${CURRENT_API_URL}/proactiveMonitoring/TransformedAlertsSaveData`,formData,{
    headers: {
        'Authorization': token,
    }
    }).then(res => {
        notify.NotifySuccess("Transformed Alerts data save successfully. Thank You!");       
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while Transformed Alerts data saving . Please try again later.");
        return false;
    });
}

export default TransformedAlertsSaveDataService;